import { Action } from "..";

import { ServiceBase } from "../../types/serviceBase";
import { SERVICE_CHANGE } from "../actions/service";

export interface ServiceState {
  service: ServiceBase | null;
}

const initialState: ServiceState = {
  service: null,
};

const serviceReducer = (
  state: ServiceState = initialState,
  action: Action
): ServiceState => {
  switch (action.type) {
    case SERVICE_CHANGE:
      return { ...state, service: action.payload };
    default:
      return state;
  }
};

export default serviceReducer;
